import { Container } from 'react-bootstrap';

import GeoMatchStepper from '@features/geomatch/geoMatchStepper';

const GeoMatch = () => {
  return (
    <Container fluid className="main-content-container h-100 bg-white overflow-scroll px-0">
      <GeoMatchStepper pageTracking="GeoMatch" />
    </Container>
  );
};

export default GeoMatch;
